export let baseUrl = process.env.VUE_APP_ENDPOINT;
export let siteUrl = process.env.VUE_APP_WEBSITE;

//custom variable set in package.json
export let debugAnalytics = process.env.VUE_APP_DEBUG.trim() == "true"; 

export const platformList = {
    web: "web",
}